/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedModelEntityModelReportResponse } from '../models/PagedModelEntityModelReportResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UploadControllerService {

  /**
   * Upload file
   * @returns PagedModelEntityModelReportResponse Process ended correctly
   * @throws ApiError
   */
  public static uploadFile({
type,
timestamp,
formData,
authorization,
}: {
type: 'MASTER' | 'PORTFOLIO' | 'HOST',
timestamp: string,
formData: {
file: Blob;
},
authorization?: string,
}): CancelablePromise<PagedModelEntityModelReportResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/upload',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'type': type,
        'timestamp': timestamp,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        403: `Unauthorized user`,
      },
    });
  }

}
